import axios from '../shared/axios';

export function getContractType(contracttypeid) {
    return axios.get(`/api/ContractType/GetContractType?id=${contracttypeid}`);
}

export function getContractTypes() {
    return axios.get(`/api/ContractType/GetList`);
}

export function saveContractType(formData) {
    return axios.put('/api/ContractType/Save', formData);
}